import gql from 'graphql-tag'

export default gql`query active_users($office_id: String, $line_manager_user_id: String){
  active_users: scheduler_users(
    office_id: $office_id, 
    line_manager_user_id: $line_manager_user_id
  ){
    user_id
    full_name
  	schedules{
      id
      active
      user_id
      start_date
      end_date
      user_schedule_type_id
      project_activity_budget_id
      project_activity_budget{
        id
        project_id
        project{
          name
        }
        description
        stage
        address{
          full_address
        }
      }
      user_project_activities{
        user_schedule_id
        user_project_activity_id
        project_id
        project{
          name
        }
        project_activity_budget_id
        project_activity_budget{
          id
          description
          stage
          address{
            full_address
          }
        }
      }
    }
    annual_leave{
      id
      start_date
      start_of_day
      end_date
      end_of_day
      status_id
      status_changed_by_user{
        user_id
        full_name
      }
      status_change_date
      created_by_user{
        user_id
        full_name
      }
      cancelled_by_user{
        user_id
        full_name
      }
    }
  }
}`